import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import Axios from 'axios'

import TeamSquad from './TeamSquad';
import TeamFixtures from './TeamFixtures';
import TeamTransfers from './TeamTransfers';
import TeamLeagues from './TeamLeagues';
import PlayerStatsSeason from './PlayerStatsSeason';

import '../FootballAPI.css'
import TeamPlayersFB from './TeamTemplates/TeamPlayersFB';
import SingleTeamInfo from './TeamTemplates/SingleTeamInfo';
import StateContext from '../../../../StateContext';
import AddPlayerTeam from './TeamEditor/AddPlayerTeam';
import { getSingleTeamById } from '../../../../api/api_football';

function SingleTeam() {

    const {id} = useParams();

    const appState = useContext(StateContext)

    const [team, setTeam] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [activeItem, setActiveItem] = useState("1")
    const [leagueName, setLeagueName] = useState();
    const [currentSeason, setCurrentSeason] = useState()

    useEffect(() => {

        async function fetchTeam() {

            setIsLoading(true)

            try {
                const data = await getSingleTeamById(id)
                setTeam(data)

            } catch (error) {
                console.log(error);
            }

            setIsLoading(false)
        }
        fetchTeam()

    }, [])

    function toggle(tab) {
        if (activeItem !== tab) {
            setActiveItem(tab)
        }
    }

    if (isLoading && !team) return <p>Laster lag..</p>

    return (
        <div className="bg-light">
            <div className="container">

                {appState.loggedIn && appState.userId === "aqX59RalZnV1sHLpS6UA1b5b4992" && (
                    <AddPlayerTeam teamId={id} />
                )}

                <SingleTeamInfo team={team} leagueName={leagueName} currentSeason={currentSeason} />

                <div className="row d-flex justify-content-between mb-1 bg-white text-center" style={{borderTop: "1px solid #e3e3e3", fontSize: "14px", cursor: "pointer" }}>
                    <div style={{width: "33.33333%"}}>
                        <div 
                            style={{backgroundColor: "transparent", border: "none"}}
                            onClick={() => toggle("1")} 
                            className={activeItem === "1" ? "btn-block text-dark p-2 z-depth-1 btn-outline-primary" : "btn-block grey-text p-2"}
                        >
                            Team
                        </div>
                    </div>
                    <div style={{width: "33.33333%"}}>
                        <div 
                            style={{backgroundColor: "transparent", border: "none"}}
                            onClick={() => toggle("2")} 
                            className={activeItem === "2" ? "btn-block text-dark p-2 z-depth-1 btn-outline-primary" : "btn-block grey-text p-2"}>
                            Fixtures
                        </div>
                    </div>
                    <div style={{width: "33.33333%"}}>
                        <div 
                            style={{backgroundColor: "transparent", border: "none"}}
                            onClick={() => toggle("3")} 
                            className={activeItem === "3" ? "btn-block text-dark p-2 z-depth-1 btn-outline-primary" : "btn-block grey-text p-2"}
                        >
                            Transfers
                        </div>
                    </div>
                    <div style={{width: "33.33333%"}}>
                        <div 
                            style={{backgroundColor: "transparent", border: "none"}}
                            onClick={() => toggle("4")} 
                            className={activeItem === "4" ? "btn-block text-dark p-2 z-depth-1 btn-outline-primary" : "btn-block grey-text p-2"}
                        >
                            Tournaments
                        </div>
                    </div>
                    <div style={{width: "33.33333%"}}>
                        <div 
                            style={{backgroundColor: "transparent", border: "none"}}
                            onClick={() => toggle("5")} 
                            className={activeItem === "5" ? "btn-block text-dark p-2 z-depth-1 btn-outline-primary" : "btn-block grey-text p-2"}
                        >
                            Squad Stats
                        </div>
                    </div>
                </div>

                {activeItem === "1" && (
                    <>
                        <TeamPlayersFB teamId={id} />
                        <TeamSquad id={id} /> 
                    </>
                )}
                {activeItem === "2" && <TeamFixtures id={id} />}
                {activeItem === "3" && <TeamTransfers teamName={team?.name} id={id} />}
                {activeItem === "4" && <TeamLeagues  id={id} />}
                {activeItem === "5" && leagueName && <PlayerStatsSeason currentSeason={currentSeason} leagueName={leagueName} id={id} season={"2019"} />}
                
            </div>
            <br/>
        </div>
    )

}
export default SingleTeam